<planning-view [Waterway]="config.data.waterway" [SelectedOperationType]="config.data.operationType"
               [SelectedMilestone]="config.data.milestone" [SelectedOperation]="config.data.operation"
               (SavingSuccessful)="SaveAndClose($event)"></planning-view>
